import _ from "lodash";
import produce from "immer";
import axios from "axios";
import strings from "../../../res/strings";

import { setAppProcessing, setAppSuccess, setAppError } from "../../common";

export const REGISTER_ACCOUNT = "authentication/REGISTER_ACCOUNT";

const REGISTER_ACCOUNT_ERRORS = {
  DEFAULT: {
    message: strings.lib_common_state_error,
  },
  EMAIL_TAKEN: {
    message: strings.lib_authentication_state_error_registration_email_taken,
  },
};

const initialState = {};

export default (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case REGISTER_ACCOUNT: {
        break;
      }

      default: {
        break;
      }
    }
  });

export const registerAccount = (
  { values, processingState, successState, errorState },
  history
) => {
  return (dispatch) => {
    dispatch(
      setAppProcessing(
        processingState ?? {
          context: "lib_registration.registerAccount",
          message: strings.lib_common_state_loading,
        }
      )
    );

    axios
      .post(
        process.env.REACT_APP_API_SERVER_HOST +
          process.env.REACT_APP_API_LIB_REGISTRATION_REGISTER_ACCOUNT,
        values
      )
      .then((response) => {
        dispatch({ type: REGISTER_ACCOUNT });
        dispatch(
          setAppSuccess(
            typeof successState === "function"
              ? successState(response, values)
              : successState ?? { context: "lib_registration.registerAccount" },
            history
          )
        );
      })
      .catch((errorResponse) => {
        let error = REGISTER_ACCOUNT_ERRORS.DEFAULT;
        if (_.get(errorResponse, "response.data.email")) {
          error = REGISTER_ACCOUNT_ERRORS.EMAIL_TAKEN;
        }

        dispatch(
          setAppError(
            typeof errorState === "function"
              ? errorState(error, values)
              : errorState ?? {
                  notificationType: "alert",
                  context: "lib_registration.registerAccount",
                  ...error,
                }
          )
        );
      });
  };
};
